// extracted by mini-css-extract-plugin
export default {"title":"Owf2X","smallViewport":"PPCdn","message":"FAObd","header":"dQ9m4"};